// @ts-strict-ignore
import React from 'react'
import { UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Box, Checkbox } from '@node-space/ui-components'
import { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'

type IntermediaryBankDetailsToggleProps = {
  checked?: boolean
  onCheckedChange: (checked: boolean) => void
  register: UseFormRegister<ContactFiatInstrumentFormData>
}

export const IntermediaryBankDetailsToggle = ({
  checked,
  onCheckedChange,
  register,
}: IntermediaryBankDetailsToggleProps) => {
  const { t } = useTranslation()

  return (
    <Box paddingT={24}>
      <Checkbox
        {...register('isIntermediaryBankDetailsRequired')}
        id="beneficiary-address-copy-details-checkbox"
        name="beneficiary-address-copy-details-checkbox"
        testId="beneficiary-address-copy-details-checkbox"
        onCheckedChange={onCheckedChange}
        label={t('contacts.intermediaryBankDetailsLabel')}
        checked={checked}
      >
        {t('contacts.intermediaryBankDetailsDescription')}
      </Checkbox>
    </Box>
  )
}
